module.exports = __webpack_public_path__ + "static/abdelghani-tie-h-7324f041c3e872d36d6f53a3f18020a7.jpg";